import {
  DatasetObjectQueryReuseHashSource,
  QueryDatasetDocument,
  QueryDatasetQuery,
  QueryDatasetQueryVariables,
  WarehouseMetaFragment,
} from '@warebee/frontend/data-access-api-graphql';
import { postProcessDatasetQuery } from '@warebee/shared/export-converter';
import { CompiledQuery } from 'kysely';
import _ from 'lodash';
import { secureClient } from '../../GraphQLClient';
import { AgentSettingsWithMeta } from '../../resourcePolicy/agentData/agent.types';
import { createAgent } from '../../simulation/store/resourcePolicy.helper';

export const delayDuration = 20 * 60 * 1000; //20min
export const cutOffDuration = 5 * 60 * 1000; //5 min
export const errorDuration = 3 * 3600 * 1000; //3 h

export function getItemKey(item: { consignee: string; sku: string }): string {
  return `${item.consignee}-${item.sku}`;
}

// function createFeedPicklist(
//   agent: string,
//   startTime: number,
//   receiveStartTime: number,
//   unknownDuration: number,
// ): FeedPicklist {
//   return {
//     id: nanoid(8),
//     agent,
//     lines: [],
//     startTime,
//     receiveStartTime,
//     endTime: null,
//     duration: 0,
//     unknownDuration,
//     origin: 'evaluated',
//   };
// }

// function createOriginalPicklists(events: FeedLatestEvent[]): FeedPicklist[] {
//   // create picklist for events where jobId and jobLine present in data

//   const picklists = _(events)
//     .groupBy(e => `${e.jobId}-${e.agentId}`)
//     .map((plEvents, picklistId) => {
//       const sorted = _.orderBy(
//         plEvents,
//         ['eventEndTime', 'eventStartTime'],
//         ['asc', 'asc'],
//       );
//       const first = _.head(plEvents);
//       const last = _.last(plEvents);
//       const picklist: FeedPicklist = {
//         id: first.jobId,
//         agent: first.agentId,
//         origin: 'data',
//         startTime: first.eventEndTime.getTime(),
//         receiveStartTime: first.eventEndTime.getTime(),
//         endTime: last.eventEndTime.getTime(),
//         duration: last.eventEndTime.getTime() - first.eventEndTime.getTime(),
//         unknownDuration: 0,
//         offsetTime: 0,
//         lines: _.map(
//           sorted,
//           (e, index) =>
//             ({
//               picklistId: e.jobId,
//               lineIndex: index,
//               consignee: e.consignee,
//               sku: e.sku,
//               quantity: e.quantity,
//               uom: e.uom,
//               locationId: e.locationId,
//               startTime:
//                 e.eventStartTime?.getTime() ?? e.eventEndTime.getTime(),
//               endTime: e.eventEndTime.getTime(),
//               receiveTime: e.eventEndTime.getTime(),
//               duration: 0,
//               durationPrevLine: e.previousStartTime
//                 ? e.eventEndTime.getTime() - e.previousStartTime.getTime()
//                 : null,
//               scans: [e],
//             }) as FeedPicklistLine,
//         ),
//       };
//       return picklist;
//     })
//     .value();

//   return picklists;
// }

// export function createPicklist(events: FeedLatestEvent[]): FeedPicklist[] {
//   const eventsWithPicklist = _.filter(events, e => !_.isNil(e.jobId));
//   const eventsToGenerate = _(events)
//     .filter(e => _.isNil(e.jobId))
//     .orderBy(['eventEndTime', 'eventStartTime'], ['asc', 'asc'])
//     .value();

//   const picklists: FeedPicklist[] = createOriginalPicklists(eventsWithPicklist);
//   let currentPl: FeedPicklist = null;
//   let plLines: FeedPicklistLine[] = [];
//   let lineIndex = 0;

//   _.forEach(eventsToGenerate, (e, index) => {
//     const isLast = index === eventsToGenerate.length - 1;

//     const duration = e.previousStartTime
//       ? e.eventEndTime.getTime() - e.previousStartTime.getTime()
//       : null;

//     if (_.isNil(currentPl) || duration > cutOffDuration) {
//       //  finalize previous pl
//       if (!_.isNil(currentPl)) {
//         const offset = _(plLines)
//           .map(l => l.receiveTime - l.startTime)
//           .min();
//         const lastLine = _.last(plLines);
//         const durationPl = lastLine.endTime - currentPl.startTime;
//         const durationPlReceived =
//           lastLine.receiveTime - currentPl.receiveStartTime;
//         currentPl.lines = plLines;
//         currentPl.endTime = lastLine.endTime;
//         currentPl.duration =
//           durationPl < 0 || durationPl > errorDuration
//             ? durationPlReceived
//             : durationPl;
//         currentPl.offsetTime = offset;
//         picklists.push(currentPl);
//       }

//       // create new pl, reset state
//       currentPl = createFeedPicklist(
//         e.agentId,
//         (e.eventStartTime ?? e.eventEndTime).getTime(),
//         e.eventEndTime.getTime(),
//         duration,
//       );
//       plLines = [];
//       lineIndex = 0;
//     }
//     const prevLine = _.last(plLines);
//     if (e.sku === prevLine?.sku && e.locationId === prevLine?.locationId) {
//       //pick same item from same location
//       prevLine.scans.push(e);
//       prevLine.quantity += 1;
//       prevLine.endTime = (e.eventStartTime ?? e.eventEndTime).getTime();
//       //prevLine.durationPrevLine += duration;
//     } else {
//       // create new picklistLine

//       plLines.push({
//         picklistId: currentPl.id,
//         lineIndex: lineIndex++,
//         consignee: e.consignee,
//         sku: e.sku,
//         quantity: 1,
//         uom: e.uom,
//         locationId: e.locationId,
//         startTime: (e.eventStartTime ?? e.eventEndTime).getTime(),
//         endTime: (e.eventStartTime ?? e.eventEndTime).getTime(),
//         receiveTime: e.eventEndTime.getTime(),
//         durationPrevLine: duration,
//         duration: 0,
//         scans: [e],
//       });
//     }

//     if (isLast) {
//       const offset = _(plLines)
//         .map(l => l.receiveTime - l.startTime)
//         .min();
//       const lastLine = _.last(plLines);
//       const durationPl = lastLine.endTime - currentPl.startTime;
//       const durationPlReceived =
//         lastLine.receiveTime - currentPl.receiveStartTime;
//       currentPl.lines = plLines;
//       currentPl.endTime = lastLine.endTime;
//       currentPl.duration =
//         durationPl < 0 || durationPl > errorDuration
//           ? durationPlReceived
//           : durationPl;
//       currentPl.offsetTime = offset;
//       picklists.push(currentPl);
//     }
//   });
//   console.debug('picklists::', picklists);
//   return picklists;
// }

// export function getAggregatedStats(
//   picklistByAggregate: Record<string, ActualityJobs>,
//   agents: AgentSettingsWithMeta[],
//   shifts: ActualityEmployeeShifts,
//   [from, to]: [Date, Date],
//   shiftCutOf: number,
// ): FeedAgentStats[] {
//   const agentSettingsById = _.keyBy(agents, a => a.id);
//   const shiftActualDurationById: Record<string, number> = {};
//   const shiftsScheduledDurationById: Record<string, number> = {};
//   const shiftDurationLabourById: Record<string, AgentLabourEventsSetting> = {};

//   _.forEach(shifts, shift => {
//     shiftActualDurationById[shift.shiftId] =
//       shift.shiftEnd.getTime() - shift.shiftStart.getTime();

//     shiftsScheduledDurationById[shift.shiftId] =
//       agentSettingsById[shift.employeeId]?.utilisation?.secondsOperation * 1000;

//     shiftDurationLabourById[shift.shiftId] =
//       agentSettingsById[shift.employeeId]?.metadata?.[
//         agentLabourMetadataPropertyName
//       ];
//   });

//   return _(picklistByAggregate)
//     .map((agentLists, agentId) => {
//       const picklistCount = _.size(agentLists);
//       const totalLines = _.sumBy(agentLists, p =>
//         _.isNumber(p.lines) ? p.timeFramedEventsCount : 0,
//       );
//       const totalUoms = _.sumBy(agentLists, l =>
//         _.isNumber(l.timeFramedUomCount) ? l.timeFramedUomCount : 0,
//       );
//       const visitedLocationsCount = _.sumBy(
//         agentLists,
//         l => l.visitedLocationsCount,
//       );

//       const netTime = _.sumBy(agentLists, p => {
//         const max = Math.max(
//           from.getTime(),
//           Math.min(to.getTime(), p.maxEventTime.getTime()),
//         );
//         const min = Math.min(
//           to.getTime(),
//           Math.max(from.getTime(), p.minEventTime.getTime()),
//         );
//         return max - min;
//       });
//       const netHours = netTime / (3600 * 1000);

//       const idleTime = _.sumBy(agentLists, p => {
//         if (_.isNil(p.minPreviousEndTime)) return 0;
//         const idleRaw =
//           Math.max(from.getTime(), p.minEventTime.getTime()) -
//           Math.max(from.getTime(), p.minPreviousEndTime.getTime());
//         return idleRaw > shiftCutOf * (3600 * 1000) ? 0 : idleRaw;
//       });

//       const grossTime = idleTime + netTime;
//       const grossHours = grossTime / (3600 * 1000);

//       const uniqueShifts = _(agentLists)
//         .flatMap(l => l.shiftIds)
//         .uniq();
//       const uniqOrders = _(agentLists)
//         .flatMap(l => l.jobGroupIds)
//         .uniq();

//       const shiftsCount = uniqueShifts.size();
//       const ordersCount = uniqOrders.size();
//       const shiftActualTime = uniqueShifts
//         .map(id => shiftActualDurationById[id])
//         .sum();
//       const shiftActualHours = shiftActualTime / (3600 * 1000);

//       const shiftScheduledTime = uniqueShifts
//         .map(id => shiftsScheduledDurationById[id])
//         .sum();
//       const shiftScheduledHours = shiftScheduledTime / (3600 * 1000);

//       const shiftLabourEventsDuration: AgentLabourEventsSetting = uniqueShifts
//         .transform((acc, shiftId) => {
//           const settings = shiftDurationLabourById[shiftId];

//           _.forEach(agentLabourEvents, e => {
//             if (!_.isNil(settings?.[e])) {
//               acc[e] = settings[e] * 1000 + (acc[e] ?? 0);
//             }
//           });
//         }, {} as AgentLabourEventsSetting)
//         .value();

//       // analyzedCost
//       // analyzedDuration
//       // analyzedDurationTravelling
//       // analyzedDurationTravellingStartEnd
//       // analyzedDistance
//       // analyzedDistanceStartEnd
//       // analyzedDurationHandling
//       // analyzedDurationPicking
//       // analyzedDurationTravellingVertical
//       // analyzedDurationReordering
//       // analyzedCost

//       const totalWeight = _.sumBy(agentLists, p =>
//         _.isNumber(p.lines) ? p.totalWeight : 0,
//       );
//       const totalVolume = _.sumBy(agentLists, p =>
//         _.isNumber(p.lines) ? p.totalVolume : 0,
//       );

//       const simulatedDuration = _.sumBy(agentLists, p =>
//         _.isNumber(p.analyzedDuration) ? p.analyzedDuration : 0,
//       );

//       const totalDistanceInternal = _.sumBy(agentLists, p =>
//         _.isNumber(p.analyzedDistance) ? p.analyzedDistance : 0,
//       );
//       const totalDistanceStartEnd = _.sumBy(agentLists, p =>
//         _.isNumber(p.analyzedDistanceStartEnd) ? p.analyzedDistanceStartEnd : 0,
//       );
//       const totalDistance = totalDistanceInternal + totalDistanceStartEnd;

//       const totalCost = _.sumBy(agentLists, p =>
//         _.isNumber(p.analyzedCost) ? p.analyzedCost : 0,
//       );

//       const netCost = _.sumBy(agentLists, p => {
//         const cps = agentSettingsById[p.agentType]?.cost?.costPerSecond ?? 0;
//         const max = Math.max(
//           from.getTime(),
//           Math.min(to.getTime(), p.maxEventTime.getTime()),
//         );
//         const min = Math.min(
//           to.getTime(),
//           Math.max(from.getTime(), p.minEventTime.getTime()),
//         );
//         return ((max - min) * cps) / 1000;
//       });

//       //performance NET
//       const netLinesPerformance = netHours > 0 ? totalLines / netHours : 0;
//       const netUomsPerformance = netHours > 0 ? totalUoms / netHours : 0;
//       const netLocationsPerformance =
//         netHours > 0 ? visitedLocationsCount / netHours : 0;
//       const netJobsPerformance = netHours > 0 ? picklistCount / netHours : 0;
//       const netOrdersPerformance = netHours > 0 ? ordersCount / netHours : 0;

//       //performance GROSS
//       const grossLinesPerformance =
//         grossHours > 0 ? totalLines / grossHours : 0;
//       const grossUomsPerformance = grossHours > 0 ? totalUoms / grossHours : 0;
//       const grossLocationsPerformance =
//         grossHours > 0 ? visitedLocationsCount / grossHours : 0;
//       const grossJobsPerformance =
//         grossHours > 0 ? picklistCount / grossHours : 0;
//       const grossOrdersPerformance =
//         grossHours > 0 ? ordersCount / grossHours : 0;

//       //performance Shift Actual
//       const shiftActualLinesPerformance =
//         shiftActualHours > 0 ? totalLines / shiftActualHours : 0;
//       const shiftActualUomsPerformance =
//         shiftActualHours > 0 ? totalUoms / shiftActualHours : 0;
//       const shiftActualLocationsPerformance =
//         shiftActualHours > 0 ? visitedLocationsCount / shiftActualHours : 0;
//       const shiftActualJobsPerformance =
//         shiftActualHours > 0 ? picklistCount / shiftActualHours : 0;
//       const shiftActualOrdersPerformance =
//         shiftActualHours > 0 ? ordersCount / shiftActualHours : 0;

//       //performance Shift Scheduled
//       const shiftScheduledLinesPerformance =
//         shiftScheduledHours > 0 ? totalLines / shiftScheduledHours : 0;
//       const shiftScheduledUomsPerformance =
//         shiftScheduledHours > 0 ? totalUoms / shiftScheduledHours : 0;
//       const shiftScheduledLocationsPerformance =
//         shiftScheduledHours > 0
//           ? visitedLocationsCount / shiftScheduledHours
//           : 0;
//       const shiftScheduledJobsPerformance =
//         shiftScheduledHours > 0 ? picklistCount / shiftScheduledHours : 0;
//       const shiftScheduledOrdersPerformance =
//         shiftScheduledHours > 0 ? ordersCount / shiftScheduledHours : 0;

//       //performance Shift Direct

//       const shiftDirectTime =
//         shiftScheduledTime - _.sum(_.values(shiftLabourEventsDuration));
//       const shiftDirectHours = shiftDirectTime / (3600 * 1000);
//       const shiftDirectLinesPerformance =
//         shiftDirectHours > 0 ? totalLines / shiftDirectHours : 0;
//       const shiftDirectUomsPerformance =
//         shiftDirectHours > 0 ? totalUoms / shiftDirectHours : 0;
//       const shiftDirectLocationsPerformance =
//         shiftDirectHours > 0 ? visitedLocationsCount / shiftDirectHours : 0;
//       const shiftDirectJobsPerformance =
//         shiftDirectHours > 0 ? picklistCount / shiftDirectHours : 0;
//       const shiftDirectOrdersPerformance =
//         shiftDirectHours > 0 ? ordersCount / shiftDirectHours : 0;

//       //performance per shift
//       const perShiftLinesPerformance =
//         shiftsCount > 0 ? totalLines / shiftsCount : 0;
//       const perShiftUomsPerformance =
//         shiftsCount > 0 ? totalUoms / shiftsCount : 0;
//       const perShiftLocationsPerformance =
//         shiftsCount > 0 ? visitedLocationsCount / shiftsCount : 0;
//       const perShiftJobsPerformance =
//         shiftsCount > 0 ? picklistCount / shiftsCount : 0;
//       const perShiftOrdersPerformance =
//         shiftsCount > 0 ? ordersCount / shiftsCount : 0;

//       const uomLineRatio = totalLines > 1 ? totalUoms / totalLines : 0;
//       const jobLineRatio = totalLines > 1 ? totalLines / picklistCount : 0;
//       const orderLineRatio = totalLines > 1 ? totalLines / ordersCount : 0;

//       const idleNetRatio = netTime > 0 ? idleTime / netTime : 0;
//       const netGrossRatio = grossTime > 0 ? netTime / grossTime : 0;
//       const activeShiftRatio =
//         shiftActualTime > 0 ? netTime / shiftActualTime : 0;
//       const utilisationScheduledRatio =
//         shiftScheduledTime > 0 ? netTime / shiftScheduledTime : 0;
//       const linesPerVisitedLocation =
//         visitedLocationsCount > 0 ? totalLines / visitedLocationsCount : 0;
//       const uomsPerVisitedLocation =
//         visitedLocationsCount > 0 ? totalUoms / visitedLocationsCount : 0;
//       const locationsPerJob =
//         picklistCount > 0 ? visitedLocationsCount / picklistCount : 0;
//       const locationsPerOrder =
//         ordersCount > 0 ? visitedLocationsCount / ordersCount : 0;

//       // Calculate total indirect labor time
//       const labourIndirectTotal = _.sum(_.values(shiftLabourEventsDuration));

//       // Calculate unknown time (idle time minus accounted labor activities, but never negative)
//       const unknownTime = Math.max(0, idleTime - labourIndirectTotal);

//       const efficiencyShiftHours =
//         netHours > 0 ? (shiftScheduledTime / netHours) * 100 : 0;

//       const totalDistancePerLine =
//         totalLines > 0 ? totalDistance / totalLines : 0;
//       const totalDistancePerOrder =
//         ordersCount > 0 ? totalDistance / ordersCount : 0;
//       const totalDistancePerJob =
//         picklistCount > 0 ? totalDistance / picklistCount : 0;

//       const internalDistancePerLine =
//         totalLines > 0 ? totalDistanceInternal / totalLines : 0;
//       const internalDistancePerOrder =
//         ordersCount > 0 ? totalDistanceInternal / ordersCount : 0;
//       const internalDistancePerJob =
//         picklistCount > 0 ? totalDistanceInternal / picklistCount : 0;

//       const durationDiff = simulatedDuration * 1000 - netTime;
//       // console.log('netTime', netTime);
//       // console.log('simulatedDuration', simulatedDuration * 1000);
//       // console.log('durationDiff', durationDiff);

//       const durationRate =
//         netTime > 0 ? (simulatedDuration * 1000) / netTime : 0;

//       // console.log('netCost', netCost);
//       // console.log('totalUoms', totalUoms);
//       const costPerUnit = netCost / totalUoms;

//       // Average net time metrics
//       const avgTimePerJob = picklistCount > 0 ? netTime / picklistCount : 0;
//       const avgTimePerOrder = ordersCount > 0 ? netTime / ordersCount : 0;

//       const fullTimeEquivalents = shiftScheduledTime / netTime;

//       const FT_WEEK_MILLIS = 40 * 3600 * 1000;

//       /* 1. Paid-hours FTE (scheduled) */
//       const fteScheduled = shiftScheduledTime / FT_WEEK_MILLIS;

//       /* 2. Worked-hours FTE (on-site clock-in to clock-out) */
//       const fteActual = shiftActualTime / FT_WEEK_MILLIS;

//       /* 3. Direct-hours FTE (productive only) */
//       const fteDirect = netTime / FT_WEEK_MILLIS;

//       const stats: FeedAgentStats = {
//         agentId,

//         picklistCount,
//         ordersCount,
//         shiftsCount,
//         totalLines,
//         totalUoms,
//         visitedLocationsCount,

//         netTime,
//         grossTime,

//         shiftActualTime,
//         shiftScheduledTime,
//         shiftDirectTime,

//         idleTime,
//         labourIndirectTotal,
//         unknownTime,

//         uomLineRatio,
//         jobLineRatio,
//         orderLineRatio,

//         netLinesPerformance,
//         netUomsPerformance,
//         netLocationsPerformance,
//         netJobsPerformance,
//         netOrdersPerformance,

//         grossLinesPerformance,
//         grossUomsPerformance,
//         grossLocationsPerformance,
//         grossJobsPerformance,
//         grossOrdersPerformance,

//         shiftActualLinesPerformance,
//         shiftActualUomsPerformance,
//         shiftActualLocationsPerformance,
//         shiftActualJobsPerformance,
//         shiftActualOrdersPerformance,

//         shiftScheduledLinesPerformance,
//         shiftScheduledUomsPerformance,
//         shiftScheduledLocationsPerformance,
//         shiftScheduledJobsPerformance,
//         shiftScheduledOrdersPerformance,

//         perShiftLinesPerformance,
//         perShiftUomsPerformance,
//         perShiftLocationsPerformance,
//         perShiftJobsPerformance,
//         perShiftOrdersPerformance,

//         ...shiftLabourEventsDuration,

//         shiftDirectLinesPerformance,
//         shiftDirectUomsPerformance,
//         shiftDirectLocationsPerformance,
//         shiftDirectJobsPerformance,
//         shiftDirectOrdersPerformance,

//         efficiencyShiftHours,
//         fullTimeEquivalents,

//         idleNetRatio,
//         netGrossRatio,
//         activeShiftRatio,
//         utilisationScheduledRatio,
//         linesPerVisitedLocation,
//         uomsPerVisitedLocation,
//         locationsPerJob,
//         locationsPerOrder,
//         totalVolume,
//         totalWeight,
//         totalCost,
//         totalDistanceInternal,
//         totalDistanceStartEnd,
//         totalDistance,
//         totalDistancePerLine,
//         totalDistancePerOrder,
//         totalDistancePerJob,
//         internalDistancePerLine,
//         internalDistancePerOrder,
//         internalDistancePerJob,
//         durationDiff,
//         durationRate,
//         netCost,
//         costPerUnit,
//         fteScheduled,
//         fteActual,
//         fteDirect,
//         avgTimePerJob,
//         avgTimePerOrder,
//       };

//       return stats;
//     })
//     .value();
// }

// export function getTotalStats(
//   agentStats: FeedAgentStats[],
//   [from, to]: [Date, Date],
// ): FeedStats {
//   const duration = to.getTime() - from.getTime();
//   const grossHours = duration / (3600 * 1000);

//   // calc aggregative
//   const totalStats = _.reduce(
//     agentStats,
//     (acc, agentStats) => {
//       return {
//         picklistCount: (acc.picklistCount ?? 0) + agentStats.picklistCount,
//         totalLines: (acc.totalLines ?? 0) + agentStats.totalLines,
//         totalUoms: (acc.totalUoms ?? 0) + agentStats.totalUoms,
//         netLinesPerformance: 0,
//         netUomsPerformance: 0,
//         grossLinePerformance: 0,
//         grossUomsPerformance: 0,
//         uomLineRatio: 0,
//         netTime: (acc.netTime ?? 0) + agentStats.netTime,
//         grossTime: (acc.grossTime ?? 0) + agentStats.grossTime,
//         idleTime: (acc.idleTime ?? 0) + agentStats.idleTime,
//       };
//     },
//     {} as FeedStats,
//   );

//   //calc averages
//   const netHours = totalStats.netTime / (3600 * 1000);
//   totalStats.netLinesPerformance =
//     netHours > 0 ? totalStats.totalLines / netHours : 0;
//   totalStats.netUomsPerformance =
//     netHours > 0 ? totalStats.totalUoms / netHours : 0;
//   totalStats.grossLinePerformance =
//     grossHours > 0 ? totalStats.totalLines / grossHours : 0;
//   totalStats.grossUomsPerformance =
//     grossHours > 0 ? totalStats.totalUoms / grossHours : 0;
//   totalStats.uomLineRatio =
//     totalStats.totalLines > 0
//       ? totalStats.totalUoms / totalStats.totalLines
//       : 0;
//   return totalStats;
// }

export type ExecuteDatasetQueryParams<TOut> = {
  warehouseId: string;
  compiledQuery: CompiledQuery<TOut>;
  comment: string;
  reuseHashSource?: DatasetObjectQueryReuseHashSource[];
};

export async function executeDatasetQuery<TOut>(
  params: ExecuteDatasetQueryParams<TOut>,
): Promise<
  [
    data: TOut[],
    columns: {
      name: string;
      type: string;
    }[],
    errors: string[],
  ]
> {
  try {
    const formattedComment = _.padEnd(
      params.comment,
      120,
      String.fromCharCode(160),
    );
    const parametersPart = _(params.compiledQuery.parameters)
      .map((p, i) => {
        const val = _.isNumber(p) ? `${p}` : `'${p}'`;
        return `-- ${_.pad(i.toString(), 2, ' ')}: ${val}`;
      })
      .join(' \n');

    const queryDescription = `
    -- ${formattedComment}
    -- warehouseId: '${params.warehouseId}' \n
    ----------------------------------- \n\n
    ${parametersPart} 
    \n`;
    const response = await secureClient.query<
      QueryDatasetQuery,
      QueryDatasetQueryVariables
    >({
      query: QueryDatasetDocument,
      variables: {
        warehouseId: params.warehouseId,
        query: queryDescription + params.compiledQuery.sql,
        params: params.compiledQuery.parameters,

        options: {
          resultReuse: !_.isEmpty(params.reuseHashSource),
          resultReuseHashSources: params.reuseHashSource,
        },
      },
    });

    const processed = postProcessDatasetQuery<TOut>(
      response.data?.warehouse?.datasetObjectQuery,
    );

    return [
      processed,
      response.data?.warehouse?.datasetObjectQuery?.columns,
      _.map(response.errors, e => e?.message),
    ];
  } catch (ex) {
    console.error(ex);
    return [[], [], [ex.message]];
  }
}

export function createFeedResources(
  agentTypes: string,
  uoms: string[],
  wh: WarehouseMetaFragment,
): AgentSettingsWithMeta[] {
  return _.map(agentTypes, agentType => {
    return createAgent({
      titles: [],
      titlePrefix: `${agentType}`,
      uoms: uoms,
      system: wh.measurementSystem,
      currencyCode: wh.currency,
    });
  });
}

// const getIntervalDate = (d: Date, aggBy: FeedActivityAggregateBy) =>
//   aggBy === 'day' ? startOfDay(d) : d;

export const getIntervalStatKey = (agentId: string, time: Date) =>
  `${agentId} - ${time.getTime()}`;
